
import '../vendors/chosen-1.8.7/chosen.jquery';

$.when( $.ready ).then(() => {
	$('select.chosen').chosen();
});